export const sortMenuItems = [
  {
    labelKey: 'sortSmartSort',
    isDynamic: true,
    sort: 'smartSort',
    order: 'ASC',
    testId: 'smartSortOption',
  },
  {
    labelKey: 'sortNewestSentAndReceived',
    sort: 'lastMessage.sentAt',
    order: 'DESC',
    testId: 'newestSentAndReceivedSortOption',
  },
  {
    labelKey: 'sortOldestSentAndReceived',
    sort: 'lastMessage.sentAt',
    order: 'ASC',
    testId: 'oldestSentAndReceivedSortOption',
  },
  {
    labelKey: 'sortNewestCaseCreated',
    sort: 'createdAt',
    order: 'DESC',
    testId: 'newestCaseCreatedSortOption',
  },
  {
    labelKey: 'sortOldestCaseCreated',
    sort: 'createdAt',
    order: 'ASC',
    testId: 'oldestCaseCreatedSortOption',
  },
];

export const DEFAULT_SELECTED_SORT_INDEX = 0;
export const DEFAULT_SELECTED_SORT =
  sortMenuItems[DEFAULT_SELECTED_SORT_INDEX].sort;
export const DEFAULT_SELECTED_SORT_ORDER =
  sortMenuItems[DEFAULT_SELECTED_SORT_INDEX].order;

export const CARD_DENSITY = {
  EXPANDED: 'expanded',
  COMFORTABLE: 'comfortable',
  COMPACT: 'compact',
};
